/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetReliabilityDataCommandResponse } from '../models';
// @ts-ignore
import type { ListClustersResponse } from '../models';
// @ts-ignore
import type { ReconcileDiscoveredClustersRequest } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * CloudAssetAPIApi - axios parameter creator
 * @export
 */
export const CloudAssetAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the command that downloads and runs the reliability data collection script.
         * @summary Get the reliability data collection command.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIGetReliabilityDataCommand: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetAPIGetReliabilityDataCommand', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-assets:getReliabilityDataCommand`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the reliability data collection script.
         * @summary Get the reliability data collection script.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIGetReliabilityDataScript: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetAPIGetReliabilityDataScript', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-assets:getReliabilityDataScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists clusters.
         * @summary Lists clusters.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIListClusters: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetAPIListClusters', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-assets/clusters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reconciles discovered clusters with existing cluster inventory.
         * @summary Reconcile discovered clusters
         * @param {string} organizationId The ID of the organization.
         * @param {ReconcileDiscoveredClustersRequest} reconcileDiscoveredClustersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIReconcileDiscoveredClusters: async (organizationId: string, reconcileDiscoveredClustersRequest: ReconcileDiscoveredClustersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetAPIReconcileDiscoveredClusters', 'organizationId', organizationId)
            // verify required parameter 'reconcileDiscoveredClustersRequest' is not null or undefined
            assertParamExists('cloudAssetAPIReconcileDiscoveredClusters', 'reconcileDiscoveredClustersRequest', reconcileDiscoveredClustersRequest)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-assets:reconcileDiscoveredClusters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reconcileDiscoveredClustersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CloudAssetAPIApi - functional programming interface
 * @export
 */
export const CloudAssetAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CloudAssetAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the command that downloads and runs the reliability data collection script.
         * @summary Get the reliability data collection command.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetAPIGetReliabilityDataCommand(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReliabilityDataCommandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetAPIGetReliabilityDataCommand(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetAPIApi.cloudAssetAPIGetReliabilityDataCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the reliability data collection script.
         * @summary Get the reliability data collection script.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetAPIGetReliabilityDataScript(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetAPIGetReliabilityDataScript(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetAPIApi.cloudAssetAPIGetReliabilityDataScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists clusters.
         * @summary Lists clusters.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetAPIListClusters(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListClustersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetAPIListClusters(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetAPIApi.cloudAssetAPIListClusters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reconciles discovered clusters with existing cluster inventory.
         * @summary Reconcile discovered clusters
         * @param {string} organizationId The ID of the organization.
         * @param {ReconcileDiscoveredClustersRequest} reconcileDiscoveredClustersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetAPIReconcileDiscoveredClusters(organizationId: string, reconcileDiscoveredClustersRequest: ReconcileDiscoveredClustersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetAPIReconcileDiscoveredClusters(organizationId, reconcileDiscoveredClustersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetAPIApi.cloudAssetAPIReconcileDiscoveredClusters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CloudAssetAPIApi - factory interface
 * @export
 */
export const CloudAssetAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CloudAssetAPIApiFp(configuration)
    return {
        /**
         * Get the command that downloads and runs the reliability data collection script.
         * @summary Get the reliability data collection command.
         * @param {CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIGetReliabilityDataCommand(requestParameters: CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetReliabilityDataCommandResponse> {
            return localVarFp.cloudAssetAPIGetReliabilityDataCommand(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the reliability data collection script.
         * @summary Get the reliability data collection script.
         * @param {CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIGetReliabilityDataScript(requestParameters: CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cloudAssetAPIGetReliabilityDataScript(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists clusters.
         * @summary Lists clusters.
         * @param {CloudAssetAPIApiCloudAssetAPIListClustersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIListClusters(requestParameters: CloudAssetAPIApiCloudAssetAPIListClustersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListClustersResponse> {
            return localVarFp.cloudAssetAPIListClusters(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Reconciles discovered clusters with existing cluster inventory.
         * @summary Reconcile discovered clusters
         * @param {CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClustersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetAPIReconcileDiscoveredClusters(requestParameters: CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClustersRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cloudAssetAPIReconcileDiscoveredClusters(requestParameters.organizationId, requestParameters.reconcileDiscoveredClustersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cloudAssetAPIGetReliabilityDataCommand operation in CloudAssetAPIApi.
 * @export
 * @interface CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommandRequest
 */
export interface CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommandRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommand
     */
    readonly organizationId: string
}

/**
 * Request parameters for cloudAssetAPIGetReliabilityDataScript operation in CloudAssetAPIApi.
 * @export
 * @interface CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScriptRequest
 */
export interface CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScriptRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScript
     */
    readonly organizationId: string
}

/**
 * Request parameters for cloudAssetAPIListClusters operation in CloudAssetAPIApi.
 * @export
 * @interface CloudAssetAPIApiCloudAssetAPIListClustersRequest
 */
export interface CloudAssetAPIApiCloudAssetAPIListClustersRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetAPIApiCloudAssetAPIListClusters
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof CloudAssetAPIApiCloudAssetAPIListClusters
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof CloudAssetAPIApiCloudAssetAPIListClusters
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for cloudAssetAPIReconcileDiscoveredClusters operation in CloudAssetAPIApi.
 * @export
 * @interface CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClustersRequest
 */
export interface CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClustersRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClusters
     */
    readonly organizationId: string

    /**
     * 
     * @type {ReconcileDiscoveredClustersRequest}
     * @memberof CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClusters
     */
    readonly reconcileDiscoveredClustersRequest: ReconcileDiscoveredClustersRequest
}

/**
 * CloudAssetAPIApi - object-oriented interface
 * @export
 * @class CloudAssetAPIApi
 * @extends {BaseAPI}
 */
export class CloudAssetAPIApi extends BaseAPI {
    /**
     * Get the command that downloads and runs the reliability data collection script.
     * @summary Get the reliability data collection command.
     * @param {CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetAPIApi
     */
    public cloudAssetAPIGetReliabilityDataCommand(requestParameters: CloudAssetAPIApiCloudAssetAPIGetReliabilityDataCommandRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetAPIApiFp(this.configuration).cloudAssetAPIGetReliabilityDataCommand(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the reliability data collection script.
     * @summary Get the reliability data collection script.
     * @param {CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetAPIApi
     */
    public cloudAssetAPIGetReliabilityDataScript(requestParameters: CloudAssetAPIApiCloudAssetAPIGetReliabilityDataScriptRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetAPIApiFp(this.configuration).cloudAssetAPIGetReliabilityDataScript(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists clusters.
     * @summary Lists clusters.
     * @param {CloudAssetAPIApiCloudAssetAPIListClustersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetAPIApi
     */
    public cloudAssetAPIListClusters(requestParameters: CloudAssetAPIApiCloudAssetAPIListClustersRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetAPIApiFp(this.configuration).cloudAssetAPIListClusters(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reconciles discovered clusters with existing cluster inventory.
     * @summary Reconcile discovered clusters
     * @param {CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClustersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetAPIApi
     */
    public cloudAssetAPIReconcileDiscoveredClusters(requestParameters: CloudAssetAPIApiCloudAssetAPIReconcileDiscoveredClustersRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetAPIApiFp(this.configuration).cloudAssetAPIReconcileDiscoveredClusters(requestParameters.organizationId, requestParameters.reconcileDiscoveredClustersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

